import { CHAT_WIDGET_VERSION } from "../../../../types/enum";
import { IChatWidgetConfig } from "../../../../utils";
import { WIDGET_CDN_URL } from "../constants";

/**
 * 生成Chat Widget Script
 * @param chatWidgetConfig
 * @param version
 * @returns
 */
export const generateScript = (chatWidgetConfig: IChatWidgetConfig, version: CHAT_WIDGET_VERSION) => {
    if (!chatWidgetConfig) {
        return;
    }
    return `<script type="module">
              import { render } from "${WIDGET_CDN_URL}/${version}.mjs";
          
              render(${JSON.stringify(chatWidgetConfig)});
            </script>`;
};
